<template>
  <div class="row leaderboard">
    <div class="col-md">
      <h1 v-html="title"></h1>
      <div class="card">
        <vue-good-table :columns="columns" :rows="filteredRecords" :pagination-options="{ enabled: true, perPage: 50 }" sort-options="sortOptions">
          <template #table-row="props">
            <span v-if="props.column.field === 'team_name'">
              <div class="team-name">{{ props.row.team_name }}</div>
              <div class="team-members text-muted" v-if="props.row.users && options['users']" v-html="props.row.users.join(' &middot; ')"></div>
            </span>
            <span v-else-if="props.column.field === 'group'">
              <div class="group-name">{{ props.row.group ? props.row.group.name : '' }}</div>
            </span>
            <span v-else-if="props.column.metric">
              <div v-if="props.row.bookmark && props.row.bookmark.metrics" class="meter" :class="props.column.metric.id">
                <div class="meter-data">
                 <div class="progress">
                    <div class="meter-value">{{ props.column.field(props.row) }}</div>
                    <div class="progress-bar" role="progressbar" :style="meterStyle(props.row, props.column.metric)"></div>
                  </div>
                </div>
              </div>
            </span>
            <span v-else-if="props.column.field === 'progress'">
              <div class="progress" style="height: 1.75rem;">
                <template v-if="props.row.bookmark">
                  <div class="progress-bar" role="progressbar" :style="`width: ${Math.round((getLocationIndex(props.row)/activePageCount) * 100)}%`">
                    <span>{{ Math.round((getLocationIndex(props.row)/activePageCount) * 100) }}%</span>
                  </div>
                </template>
              </div>
            </span>
            <span v-else-if="props.column.field === 'progress_ratio'">
              <template v-if="props.row.bookmark">
                <ProgressRatio :locationIndex="getLocationIndex(props.row)" :completed="props.row.completed" :pageType="props.row.bookmark.pageType" :pageCount="activePageCount" :isQuestion="isQuestion(props.row)"/>
              </template>
            </span>
            <span v-else-if="props.column.field === 'session_progress'" :set="subSessionData = getSubSessionData(props.row)">
              <div class="progress" style="height: 1.75rem;">
                <template v-if="props.row.bookmark">
                    <div class="progress-bar" role="progressbar" :style="`width: ${Math.round((subSessionData.pageIndex/subSessionData.count) * 100)}%`">
                      <span>{{ Math.round((subSessionData.pageIndex/subSessionData.count) * 100) }}%</span>
                    </div>
                </template>
              </div>
            </span>
            <span v-else-if="props.column.field === 'session_progress_ratio'" :set="subSessionData = getSubSessionData(props.row)">
                <template v-if="props.row.bookmark">
                    <ProgressRatio :locationIndex="subSessionData.pageIndex" :completed="props.row.completed" :pageType="props.row.bookmark.pageType" :pageCount="subSessionData.count" :isQuestion="isQuestion(props.row)"/>
                </template>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <div class="card-footer">
          <div class="small">Scores will update automatically, do not refresh this page.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import leaderboardMixin from '../mixins/leaderboard'
import { VueGoodTable } from 'vue-good-table-next'
import ProgressRatio from './ProgressRatio.vue'
import { Echo } from '../../common/socket'

export default {
  mixins: [leaderboardMixin],
  components: {
    VueGoodTable,
    ProgressRatio
  },
  props: ['options'],
  data () {
    let metrics = _.get(this.session, 'publication.content.metrics', [])

    if (typeof metrics === 'string') {
      try {
        metrics = JSON.parse(metrics, (k, v) => {
          return (typeof v === 'object' || isNaN(v)) ? v : parseInt(v, 10)
        })
      } catch (err) {
        console.error(err)
      }
    }

    const columns = [{
      label: '#',
      type: 'number',
      field: 'rank',
      tdClass: 'vgt-center-align rank',
      thClass: 'vgt-center-align',
      width: '50px'
    }, {
      label: 'Team',
      field: 'team_name',
      filterOptions: {
        enabled: true
      }
    }]

    if (this.options.groups) {
      columns.push({
        label: 'Group',
        field: 'group',
        filterOptions: {
          enabled: true,
          filterFn: this.filterGroups
        }
      })
    }

    if (this.options.meters) {
      console.log(metrics)
      _.each(metrics, (metric, index) => {
        columns.push({
          label: metric.label,
          field: (record) => {
            const meters = _.get(record, 'bookmark.metrics', [])
            const meter = _.find(meters, { id: metric.id })
            return meter ? meter.value : 0
          },
          metric: metric,
          meterID: metric.id,
          meterIndex: index,
          thClass: 'vgt-center-align',
          tdClass: 'vgt-center-align',
          type: 'number',
          width: '11%',
        })
      })
    }

    if (this.options.progress) {
      columns.push({
        label: 'Overall Progress (%)',
        field: 'progress',
        tdClass: 'vgt-center-align',
        thClass: 'vgt-center-align',
        type: 'number',
        width: '11%',
      })
    }

    if (this.options.progress_ratio) {
      columns.push({
        label: 'Overall Progress (x/xx)',
        field: 'progress_ratio',
        type: 'number',
        tdClass: 'vgt-center-align',
        thClass: 'vgt-center-align',
      })
    }

    if (this.session.publication.content.sub_sessions && this.options.session_progress) {
      columns.push({
        label: 'Session Progress (%)',
        field: 'session_progress',
        type: 'number',
        tdClass: 'vgt-center-align',
        thClass: 'vgt-center-align',
        sortable: false
      })
    }

    if (this.session.publication.content.sub_sessions && this.options.session_progress_ratio) {
      columns.push({
        label: 'Session Progress (x/xx)',
        field: 'session_progress_ratio',
        type: 'number',
        tdClass: 'vgt-center-align',
        thClass: 'vgt-center-align',
        sortable: false
      })
    }

    if (this.options.composite) {
      columns.push({
        label: 'Score',
        field: 'composite_score',
        type: 'number',
        tdClass: 'vgt-center-align score',
        thClass: 'vgt-center-align',
        width: '85px'
      })
    }

    return {
      records: this.session.records || [],
      metrics: metrics,
      columns: columns,
      sortOptions: {
        enabled: true,
        initialSortBy: {
          field: 'rank',
          type: 'asc'
        }
      }
    }
  },
  computed: {
    title() {
      if (this.session.leaderboard_title) {
        return this.session.leaderboard_title
      }
      return  `${this.session.name } <small class="text-muted">Leaderboard</small>`
    },
    displayOptions () {
      var options = this.options || { }
      return _.keys(options);
    },
    filteredRecords () {
      const filtered = _.cloneDeep(this.rankedRecords)
      _.each(filtered, (record, index) => {
        record.rank = index + 1
        record.progress_ratio = this.getLocationIndex(record)
        record.progress = Math.round((this.getLocationIndex(record)/this.activePageCount) * 100)
      })
      return filtered
    },
    rankedRecords () {
      return _.sortBy(this.records, (record) => {
        return -record.composite_score
      })
    },
  },
  methods: {
    refresh () {
      axios.get('/api/leaderboard/' + this.session.id)
        .then((response) => {
          console.log(response)
          if (response.data.results) {
            this.records = response.data.results.concat()
          }
        })
        .catch((response) => {
          console.log(response)
        })
    },
    getMeter (record, id) {
      const meters = _.get(record, 'bookmark.metrics', []);
      return _.find(meters, { id: id })
    },
    meterStyle (record, metric) {
      const meter = this.getMeter(record, metric.id)
      
      // get meter width
      const minMod = (0 - meter.min)
      const percent = (meter.value + minMod) / (meter.max + minMod)

      // get brand color
      let color = '#999'
      if (metric.id === 'meter-1') {
        color = this.brandColors.primary
      } else if (metric.id === 'meter-2') {
        color = this.brandColors.secondary
      } else if (metric.id === 'meter-3') {
        color = this.brandColors.tertiary
      } else if (metric.id === 'meter-4') {
        color = this.brandColors.meter4
      } else if (metric.id === 'meter-5') {
        color = this.brandColors.meter5
      }

      if (this.book.theme) {
        return `width: ${percent * 100}%;`
      } else {
        return `width: ${percent * 100}%; background: ${color};`
      }

    },
    filterGroups(row, filterString) {
      if (row && row.name) {
        return row.name.toLowerCase() === filterString.toLowerCase()
      } else {
        return true
      }
    }
  },
  mounted () {
    const channelPrefix = document.head.querySelector('meta[name="broadcast-channel-prefix"]')
    Echo.channel(channelPrefix.content + '.records')
      .listen('RecordDeleted', (response) => {
        this.records = _.filter(this.records, function(record) {
          return record.id != response.record_id
        })
      })
  }
}
</script>

<style lang="scss">

.leaderboard {
  font-size: 1.25rem;

  .rank,
  .score,
  .team-name,
  .team-members {
    font-size: 1.25rem;
  }

  .rank,
  .score,
  .team-name {
    font-weight: 700;
  }

  .progress {
    font-size: 1rem;
  }

  table {
    
    &.vgt-table {

      td {
        vertical-align: middle;
      }
    }
  }

  .meter {
    margin-bottom: 10px;
    margin: 0;

    .meter-label {
      line-height: 1.25rem;
      font-size: 0.875rem;
      margin-left: -0.5rem;
      margin-right: -0.5rem;
    }

    .meter-min,
    .meter-max {
      font-size: 0.75rem;
    }

    .meter-value {
      font-size: 1rem;
      color: #fff;
      text-align: center;
    }

    .progress {
      margin: 5px;
      height: 1.75rem;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .meter-data {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .meter-label {
    font-size: 0.75rem;
  }

  .meter-value {
    position: absolute;
    left: 0;
    top: 14px;
    width: 100%;
    font-size: 0.875rem;
    font-weight: 700;
    text-shadow: 1px 1px 1px #000;
  }

  .progress {
    position: relative;
    border-radius: 5px;
    border: 1px solid #ccc;
    flex-grow: 1;
    margin: 0 5px;
    height: 1.375rem;
  }

  .meter-min,
  .meter-max {
    font-size: 0.5rem;
  }
}

</style>